import { useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import { AppRoute, ButtonType } from '../../types/enums';
import { Website } from '../../types/types';
import { getDashboardUrlById } from '../../utils/common';
import Button from '../Button/Button';

import styles from './WebsiteCreated.module.scss';

const WebsiteCreated = () => {
  const navigate = useNavigate();
  const { state }: { state: Website | null } = useLocation();

  useEffect(() => {
    if (!state?.id) {
      navigate(AppRoute.WEBSITES);
    }
  }, []);

  return (
    <div>
      <h3>{state?.name}</h3>
      <p>
        We will check&nbsp;
        <a target="_blank" rel="noreferrer" className={styles.link} href={state?.url}>
          {state?.url}
        </a>
        &nbsp; in a few minutes and display the results in the administration table and on the
        related dashboards.
      </p>
      {(state?.dashboards || []).length > 0 && (
        <>
          <h3>Dashboards:</h3>
          <p>The website is displayed on the following dashboards:</p>
          <ul className={styles.list}>
            {state?.dashboards?.map(({ id, name }) => (
              <li key={id}>
                <a target="_blank" rel="noreferrer" href={getDashboardUrlById(id)}>
                  {name}
                </a>
              </li>
            ))}
          </ul>
        </>
      )}
      <div className="flex">
        <NavLink to={AppRoute.WEBSITE_NEW}>
          <Button type={ButtonType.PRIMARY}>Add new website</Button>
        </NavLink>
        <NavLink className={styles.link} to={AppRoute.WEBSITES}>
          GO TO WEBSITE LIST
        </NavLink>
      </div>
    </div>
  );
};

export default WebsiteCreated;
